export const BRAND = {
  name: "MetaJuntos",
  poweredBy: "powered by Guedes Investe",
  title: "MetaJuntos | Controle financeiro pessoal e compartilhado",
  description:
    "MetaJuntos e uma plataforma de controle financeiro pessoal e compartilhado, powered by Guedes Investe.",
  shortDescription: "Plataforma de controle financeiro pessoal e compartilhado.",
  siteUrl: "https://metajuntos.com.br",
} as const;
